function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SignatureV4 } from '@aws-sdk/signature-v4';
import { CryptoHash } from './util/crypto-hash';
import { dateUtil } from './util/utils';
const sha256 = CryptoHash;
export class Signer {
  constructor(credential, region, service) {
    _defineProperty(this, "credential", void 0);
    _defineProperty(this, "awsSignatureV4", void 0);
    _defineProperty(this, "region", void 0);
    this.credential = credential;
    this.region = region;
    this.awsSignatureV4 = new SignatureV4({
      credentials: {
        accessKeyId: this.credential.accessKeyId,
        secretAccessKey: this.credential.secretKey,
        sessionToken: this.credential.sessionToken,
        expiration: new Date(this.credential.expiration * 1000)
      },
      sha256,
      region,
      service,
      uriEscapePath: true
    });
  }
  async sign(request) {
    const requestToBeSigned = {
      ...request,
      headers: {
        ...request.headers,
        host: request.hostname
      }
    };
    return this.awsSignatureV4.sign(requestToBeSigned, {
      signingDate: dateUtil.getDateWithClockOffset(),
      signingRegion: this.region,
      signingService: 'mobiletargeting'
    });
  }
  async signStr(str) {
    return this.awsSignatureV4.sign(str, {
      signingRegion: this.region,
      signingService: 'mobiletargeting'
    });
  }
}